import { render, staticRenderFns } from "./newsKAB.vue?vue&type=template&id=2392e452"
import script from "./newsKAB.vue?vue&type=script&lang=js"
export * from "./newsKAB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports